/**
 * 通用混合
 * */
import { getHeaderName, getMenuSider, getSiderSubmenu,getSiderOpenNames} from '@/libs/ab-system';
export default {
    methods: {
        // 当 $route 更新时触发
        appRouteChange (to, from) {
		
			this.$store.commit('admin/menu/setActivePath', to.path);//解决带参数路由无法高亮问题
	
			this.$store.dispatch('admin/db/database', { user: true }).then((db)=>{//获取用户菜单
			
				const menuList = db.get('userMenuList').value();//获取用户菜单
	        	const headerName = getHeaderName(to.path, menuList,to.fullPath);//获取头部菜单
				
	            // 在 404 时，是没有 headerName 的
	            if (headerName) {//如果有头部菜单
	            	//通过headName 取到下属的菜单
			        const menuSider = getMenuSider(menuList,headerName);//获取侧边栏菜单


		        	this.$store.commit("admin/menu/setSider", menuSider);//设置侧边栏菜单
	                this.$store.commit('admin/menu/setHeaderName', headerName);//设置头部菜单
	                // 解决带参数路由无法高亮问题
	                this.$store.commit('admin/menu/setActivePath', to.fullPath);//设置当前路由
	                const openNames = getSiderOpenNames(to.fullPath, menuSider);//获取当前路由的父级路由
	                if(openNames.length>0){//如果有父级路由
		                this.$store.commit('admin/menu/setOpenNames', openNames);//设置父级路由
	                }
	           }
			})
        }
    }
}
